import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z", stroke: `${color}` })
    }
  );
};
Icon.displayName = "MessageCircle";
const MessageCircle = memo(themed(Icon));
export {
  MessageCircle
};
//# sourceMappingURL=message-circle.js.map
